import React from 'react'
import YumSelect, { YumSelectProps } from '../YumSelect/YumSelect'
import Autocomplete from '@material-ui/lab/Autocomplete'
import YumField from '../YumInput/YumInput'
import { t } from 'ttag'
import { SelectInputProps } from '@material-ui/core/Select/SelectInput'
import { DivisionDto, DivisionRow } from '../../services/api.types'

import { ReactComponent as GroupActiveIcon } from '../../assets/v3/icons/group-active.svg'
import { ReactComponent as GroupInactiveIcon } from '../../assets/v3/icons/group-inactive.svg'

interface YumGroupSelectProps extends YumSelectProps {
  groups: DivisionDto[]
  required?: boolean

  onChange?: SelectInputProps['onChange']
  value?: unknown
  error?: any
  label?: any
  style?: any
  ref?: any

  startIcon?: any
  startInactiveIcon?: any

  showIcon?: boolean
  useAutocompleteSelect?: boolean
  isDuringRegistration?: boolean

  isAdmin?: boolean
  maxGroupSize?: number
  verticalPadding?: number
}

export default function YumGroupSelect({
  groups,
  required,
  value,
  showIcon,
  useAutocompleteSelect,
  disabled,
  isAdmin,
  maxGroupSize,
  isDuringRegistration,
  ...props
}: YumGroupSelectProps) {
  const { ref, verticalPadding, ...otherProps } = props

  const getOptionDisabled = (option: DivisionRow) => {
    if (isAdmin) return false
    const isLocked = option.locked
    const exceedsMaxGroupSize = !!maxGroupSize && option.members >= maxGroupSize
    return isLocked || exceedsMaxGroupSize
  }

  const getOptionLabel = (option: DivisionRow) => {
    return option.name + (maxGroupSize ? ` (${option.members}/${maxGroupSize})` : '')
  }

  return useAutocompleteSelect ? (
    <Autocomplete
      disabled={disabled}
      getOptionDisabled={getOptionDisabled}
      clearText={t`Clear`}
      closeText={t`Close`}
      openText={t`Open`}
      noOptionsText={t`No options`}
      openOnFocus
      onChange={(event, newValue) => {
        // @ts-ignore
        props.onChange?.({ target: { value: newValue?.id } }, null)
      }}
      options={groups}
      value={groups.find((g) => g.id === value) || null}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <YumField
          {...params}
          label={props.label}
          style={props.style}
          startIcon={showIcon && GroupInactiveIcon}
          value={value}
          error={props.error}
          variant="filled"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            // This disables the browser autocomplete.
            autoComplete: 'new-password',
          }}
          fullWidth={true}
          type="text"
        />
      )}
    />
  ) : (
    <YumSelect
      disabled={disabled}
      {...otherProps}
      value={value}
      startIcon={showIcon && GroupInactiveIcon}
      verticalPadding={verticalPadding}
    >
      {required && !isDuringRegistration ? '' : <option value="" />}
      {groups.map((group, keyIndex) => (
        <option key={keyIndex} value={group.id || ''} disabled={getOptionDisabled(group)}>
          {getOptionLabel(group)}
        </option>
      ))}
    </YumSelect>
  )
}
